import { useMemo } from 'react';

import { AdditionalRequirementType } from '~libs.shared.prescription';

import { AdditionalRequirement } from './additionalRequirements.types';

type AdditionalRequirementsSelectorOptions = {
   initialAdditionalRequirementTypes: AdditionalRequirementType[] | undefined;
};

export const useAdditionalRequirementsSelector = (
   options: AdditionalRequirementsSelectorOptions
): AdditionalRequirement[] =>
   useMemo(() => {
      if (options.initialAdditionalRequirementTypes?.length) {
         return options.initialAdditionalRequirementTypes.map((additionalRequirementType) => ({
            type: additionalRequirementType,
         }));
      }

      return [];
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
